import { graphql } from 'react-relay';

export const fundsDetailPageGFragment = graphql`
  fragment FundsDetailsPage_page on FundsDetailsPage 
    @argumentDefinitions(
        salesAdmission: {type: "String!"}
    ) {
      components(first: 10000) {
        edges {
          node {
            id
            __typename
            ...ArchiveList_component
            ...BaseData_component @arguments(salesAdmission: $salesAdmission)
            ...PerformanceOverview_component
            ...PerformanceByYear_component
            ...FundsIntroduction_component
            ...TrancheSelection_component
            ...Widget_component @arguments(salesAdmission: $salesAdmission, componentsCount: 10000)
            ... on Widget {
              components ( first: 10000 ) {
                edges {
                  node {
                    __typename
                  }
                }
              }
            }
          }
        }
      }
      largeinvestmentfonds
      reportcurrency
      breadcrumbs {
        ...Breadcrumb_data
      }
      path
      id
    }
`;
